module.exports = __webpack_public_path__ + "static/bltc_icon-e8933e699186201de60db5c3040acd7b.png";